import React from "react";
import Loading from "../../components/common/loading";
import { formatDistanceToNow } from "date-fns";

import { Switch, Route, Redirect, matchPath } from "react-router-dom";

import SubHeader from "../../components/common/topHeader/subHeader";
// import CalenderInput from "../../components/common/inputs/calenderInput";
import DevicePageInlet from "./sections/devicePageInlet";
import DevicePageOutlets from "./sections/devicePageOutlet";
import DevicePageOutletPage from "./sections/devicePageOutletPage";
import DevicePageSensors from "./sections/devicePageSensors";
import DevicePageAlerts from "./sections/devicePageAlerts";
import DevicePageAlertItemPage from './deviceAlertsItemPage';
import DeviceAlertDetails from "./sections/deviceAlertDetails";
import LoggingEventLogs from '../logging/eventLogs';
import DevicePageConfiguration from "./sections/devicePageConfiguration";
import DevicePageDiagnostics from "./sections/devicePageDiagnostics";
import DeviceOverview from "./sections/deviceOverview";
import NotFoundPage from "../notFound";
import { evaluateShellApiVersion } from "./sections/shellApiVersionSupport";
import { getEffectiveDevicePermissions } from "../../utils/devicePermissions";
import { apiErrorMessageFromError } from "../../utils/apiErrorMessage";
import { isApiVersionGte } from "../../utils/deviceApiVersion";
import {
  buildAlertDetailsPath,
  buildAlertEditPath,
  buildAlertLogsPath,
  buildDeviceAlertsPath,
} from "../../utils/deviceAlertUtils";

import axios from "axios";
import NotificationManager from "../../utils/notificationManager";
export default class ConnectedDevicePage extends React.Component {
  outletsRequest = null;
  inletsRequest = null;
  banksRequest = null;
  sensorsRequest = null;
  eventsRequest = null;
  confRequest = null;
  confRequestSerial = null;

  state = {
    device: null,
    deviceLoading: false,
    deviceLoaded: false,

    outletsLoading: false,
    outletsLoaded: false,
    inletsLoading: false,
    inletsLoaded: false,
    banksLoading: false,
    banksLoaded: false,
    sensorsLoading: false,
    sensorsLoaded: false,
    eventsLoading: false,
    eventsLoaded: false,

    conf: null,
    confLoading: false,
    confSerial: null,

    deviceOffline: false,
    deviceOfflineReason: null,

    activityLoading: false,
    activityLog: [],
    activityMeta: {},
    activityPage: 1,
    activityLoaded: false,
    activityFilter: "",
    activitySerial: null,
  };

  normalizeDevice = (device) => {
    if (!device) return null;

    const normalizedSerial =
      device.enclosureSerialNumber === undefined ||
      device.enclosureSerialNumber === null
        ? device.enclosureSerialNumber
        : String(device.enclosureSerialNumber);

    return {
      ...device,
      enclosureSerialNumber: normalizedSerial,
      outlets: Array.isArray(device.outlets) ? device.outlets : [],
      inlets: Array.isArray(device.inlets) ? device.inlets : [],
      sensors: Array.isArray(device.sensors) ? device.sensors : [],
      banks: Array.isArray(device.banks) ? device.banks : [],
      events: Array.isArray(device.events) ? device.events : [],
    };
  };

  setDeviceData = (data, extraState = {}) => {
    if (!data) {
      this.setState(extraState);
      return;
    }

    if (
      data.enclosureSerialNumber !== undefined &&
      data.enclosureSerialNumber !== null &&
      !this.isRouteSerial(data.enclosureSerialNumber)
    ) {
      return;
    }

    this.setState((prevState) => {
      const prevDevice = prevState.device;
      const prevSerialRaw = prevDevice?.enclosureSerialNumber;
      const prevSerial =
        prevSerialRaw === undefined || prevSerialRaw === null
          ? prevSerialRaw
          : String(prevSerialRaw);
      const nextSerialRaw =
        data.enclosureSerialNumber !== undefined
          ? data.enclosureSerialNumber
          : prevSerialRaw;
      const nextSerial =
        nextSerialRaw === undefined || nextSerialRaw === null
          ? nextSerialRaw
          : String(nextSerialRaw);

      const isNewSerial =
        Boolean(nextSerial) &&
        (prevSerial === undefined || prevSerial === null
          ? true
          : nextSerial !== prevSerial);

      const baseDevice = isNewSerial ? {} : prevDevice || {};
      const mergedDevice = this.normalizeDevice({
        ...baseDevice,
        ...data,
      });

      const resetFlags = isNewSerial
        ? {
            outletsLoading: false,
            outletsLoaded: false,
            inletsLoading: false,
            inletsLoaded: false,
            banksLoading: false,
            banksLoaded: false,
            sensorsLoading: false,
            sensorsLoaded: false,
            eventsLoading: false,
            eventsLoaded: false,
            activityLoading: false,
            activityLog: [],
            activityMeta: {},
            activityPage: 1,
            activityLoaded: false,
            activitySerial: null,
          }
        : {};

      return {
        device: mergedDevice,
        ...resetFlags,
        ...extraState,
      };
    });
  };

  deviceSupportsOutlets = () => {
    const device = this.state.device;
    if (!device) return null;

    return Boolean(
      device.outletSwitchingSupported || device.outletPwrMeasurementsSupported
    );
  };

  isOfflineError = (error) => {
    return (
      error?.response?.status === 503 &&
      error?.response?.data?.code === "DEVICE_OFFLINE"
    );
  };

  offlineMessageFromError = (error, fallback = "Device is offline.") => {
    return error?.response?.data?.message || fallback;
  };

  isAdminUser = () =>
    Boolean(
      this.props.user?.is_enterprise_admin ||
        this.props.user?.has_admin_privileges,
    );

  getShellState = () => {
    const compatibility = evaluateShellApiVersion(this.state.device?.apiVersion);
    const isAdmin = this.isAdminUser();
    const isCompatibilityKnown =
      this.state.deviceLoaded ||
      (this.state.device?.apiVersion !== undefined &&
        this.state.device?.apiVersion !== null);

    return {
      isAdmin,
      showShellTab: isAdmin,
      isCompatible: isCompatibilityKnown ? compatibility.isCompatible : null,
      isCompatibilityKnown,
      apiVersionRaw: compatibility.apiVersionRaw,
      apiVersionNumber: compatibility.apiVersionNumber,
      reasonCode: compatibility.reasonCode,
      warningMessage:
        isAdmin && isCompatibilityKnown && !compatibility.isCompatible
          ? "Shell requires API version 1.2 or newer. Update firmware to continue."
          : "",
    };
  };

  currentSerial = () => {
    const rawSerial =
      this.getRouteSerial() ??
      this.state.device?.enclosureSerialNumber;
    return rawSerial === undefined || rawSerial === null
      ? rawSerial
      : String(rawSerial);
  };

  getRouteSerial = (props = this.props) => {
    const rawSerial = props.match?.params?.enclosureSerialNumber;
    return rawSerial === undefined || rawSerial === null
      ? rawSerial
      : String(rawSerial);
  };

  isRouteSerial = (serial, props = this.props) => {
    const routeSerial = this.getRouteSerial(props);
    if (!routeSerial || serial === undefined || serial === null) {
      return true;
    }

    return String(serial) === routeSerial;
  };

  getDevicePermissionsFor = (props = this.props, state = this.state) =>
    getEffectiveDevicePermissions({
      user: props.user,
      resources: props.resources,
      enclosureSerialNumber:
        props.match?.params?.enclosureSerialNumber ??
        state.device?.enclosureSerialNumber,
    });

  devicePermissionsChanged = (previousPermissions, nextPermissions) => {
    const keys = [
      "ready",
      "canViewInlets",
      "canViewOutlets",
      "canViewEvents",
      "canViewSensors",
      "canViewActivityLog",
      "canEditDeviceInfo",
      "canEditOutlets",
      "canSwitchOutlets",
      "canEditEvents",
      "canViewFirmware",
    ];

    return keys.some(
      (key) => previousPermissions?.[key] !== nextPermissions?.[key],
    );
  };

  ensurePermissionAwareData = (
    pathname = this.props.location.pathname,
    permissions = this.getDevicePermissionsFor(),
  ) => {
    if (!permissions.ready) return;

    this.ensureSectionData(pathname, permissions);
    const path = pathname || "";
    if (path.includes("/outlets")) {
      this.ensureActivityLogLoaded(permissions);
    }
    if (path.includes("/configuration")) {
      this.ensureFirmwareStatusLoaded(permissions);
    }
  };

  ensureActivityLogLoaded = (permissions = this.getDevicePermissionsFor()) => {
    const serial = this.currentSerial();
    if (!serial || !permissions.ready || !permissions.canViewActivityLog) {
      return;
    }

    if (
      this.state.activityLoading ||
      (this.state.activityLoaded && this.state.activitySerial === serial)
    ) {
      return;
    }

    this.grabActivityLog(1, this.state.activityFilter, permissions);
  };

  ensureFirmwareStatusLoaded = (permissions = this.getDevicePermissionsFor()) => {
    const serial = this.currentSerial();
    if (!serial || !permissions.ready || !permissions.canViewFirmware) {
      return;
    }

    const existingStatus = (this.props.resources?.fwStatus || []).find(
      (status) => `${status?.enclosureSerialNumber}` === `${serial}`,
    );

    if (existingStatus?.loading || existingStatus?.loaded) {
      return;
    }

    this.props.fetchFwStatus(serial);
  };

  getCachedDeviceForSerial = (serial = this.getRouteSerial()) => {
    if (!serial) return null;

    return this.props.resources.devices?.find(
      (d) =>
        d?.enclosureSerialNumber !== undefined &&
        d?.enclosureSerialNumber !== null &&
        String(d.enclosureSerialNumber) === String(serial)
    );
  };

  loadRouteDevice = ({ reset = false } = {}) => {
    const foundDevice = this.getCachedDeviceForSerial();

    if (reset) {
      this.outletsRequest = null;
      this.inletsRequest = null;
      this.banksRequest = null;
      this.sensorsRequest = null;
      this.eventsRequest = null;
      this.confRequest = null;
      this.confRequestSerial = null;
    } else if (foundDevice) {
      this.setDeviceData(foundDevice);
    }

    const nextState = {
      deviceLoading: true,
      deviceLoaded: false,
    };

    if (reset) {
      Object.assign(nextState, {
        device: foundDevice ? this.normalizeDevice(foundDevice) : null,
        outletsLoading: false,
        outletsLoaded: false,
        inletsLoading: false,
        inletsLoaded: false,
        banksLoading: false,
        banksLoaded: false,
        sensorsLoading: false,
        sensorsLoaded: false,
        eventsLoading: false,
        eventsLoaded: false,
        conf: null,
        confLoading: false,
        confSerial: null,
        deviceOffline: false,
        deviceOfflineReason: null,
        activityLoading: false,
        activityLog: [],
        activityMeta: {},
        activityPage: 1,
        activityLoaded: false,
        activitySerial: null,
      });
    }

    this.setState(nextState, () => {
      this.grabDeviceData();
      this.ensureDeviceGroupsLoaded();
      this.ensurePermissionAwareData();
    });
  };

  componentDidMount() {
    this.loadRouteDevice();
  }

  componentDidUpdate(prevProps, prevState) {
    const prevRouteSerial = this.getRouteSerial(prevProps);
    const nextRouteSerial = this.getRouteSerial(this.props);

    if (nextRouteSerial !== prevRouteSerial) {
      this.loadRouteDevice({ reset: true });
      return;
    }

    if (
      !this.state.device &&
      this.props.resources.devices !== prevProps.resources.devices
    ) {
      const foundDevice = this.getCachedDeviceForSerial();
      if (foundDevice) {
        this.setDeviceData(foundDevice);
      }
    }

    const prevSerialRaw = prevState.device?.enclosureSerialNumber;
    const currentSerialRaw = this.state.device?.enclosureSerialNumber;
    const prevSerial =
      prevSerialRaw === undefined || prevSerialRaw === null
        ? prevSerialRaw
        : String(prevSerialRaw);
    const currentSerial =
      currentSerialRaw === undefined || currentSerialRaw === null
        ? currentSerialRaw
        : String(currentSerialRaw);
    const previousPermissions = this.getDevicePermissionsFor(prevProps, prevState);
    const currentPermissions = this.getDevicePermissionsFor(this.props, this.state);
    const permissionsChanged = this.devicePermissionsChanged(
      previousPermissions,
      currentPermissions,
    );

    if (currentSerial && currentSerial !== prevSerial) {
      this.fetchConf({ useCache: false, device: this.state.device, force: true });
    }

    if (
      currentSerial !== prevSerial ||
      this.props.location.pathname !== prevProps.location.pathname ||
      (!prevState.deviceLoaded && this.state.deviceLoaded) ||
      prevProps.resources.groupsLoaded !== this.props.resources.groupsLoaded ||
      prevProps.resources.groups !== this.props.resources.groups ||
      permissionsChanged
    ) {
      this.ensurePermissionAwareData(
        this.props.location.pathname,
        currentPermissions,
      );
    }

    this.ensureDeviceGroupsLoaded();
  }

  ensureDeviceGroupsLoaded = () => {
    const resources = this.props.resources || {};
    if (!this.props.fetchResource) return;

    if (!resources.groupsLoaded && !resources.groupsLoading) {
      this.props.fetchResource("groups");
    }
  };

  grabDeviceData = () => {
    const serial = this.getRouteSerial();
    this.props.getDeviceItemAndData(serial, (err, res) => {
      if (!this.isRouteSerial(serial)) {
        return;
      }

      if (err) {
        console.error("Error fetching device data:", err);
        this.setState({
          deviceLoading: false,
          deviceLoaded: true,
        });
        return;
      }

      const deviceData = res?.data?.data;
      const offline = Boolean(res?.offline);
      const offlineMessage = offline
        ? res?.message || "Device is offline. Displaying last known information."
        : null;

      this.setDeviceData(deviceData, {
        deviceLoading: false,
        deviceLoaded: true,
        deviceOffline: offline,
        deviceOfflineReason: offline ? offlineMessage : null,
      });
      this.ensureSectionData(this.props.location.pathname);
    });
  };

  ensureSectionData = (
    pathname = this.props.location.pathname,
    permissions = this.getDevicePermissionsFor(),
  ) => {
    const serial = this.currentSerial();
    if (!serial || !permissions.ready) return;

    const path = pathname || "";
    const supportsOutlets = this.deviceSupportsOutlets();
    const shouldFetchOutlets =
      supportsOutlets === true && permissions.canViewOutlets;

    if (path.includes("/outlets") && shouldFetchOutlets) {
      this.fetchDeviceOutlets();
    }

    if (path.includes("/inlets") && permissions.canViewInlets) {
      this.fetchDeviceInlets();
      this.fetchDeviceBanks();
    }

    if (path.includes("/alerts")) {
      if (isApiVersionGte(this.state.device?.apiVersion, "1.2")) {
        this.fetchConf({ useCache: true });
      }
      if (permissions.canViewEvents) {
        this.fetchDeviceEvents();
      }
      if (shouldFetchOutlets) {
        this.fetchDeviceOutlets();
      }
      if (permissions.canViewInlets) {
        this.fetchDeviceInlets();
        this.fetchDeviceBanks();
      }
      if (permissions.canViewSensors) {
        this.fetchDeviceSensors();
      }
    }

    if (path.includes("/sensors") && permissions.canViewSensors) {
      this.fetchDeviceSensors();
    }

    if (path.includes("/overview")) {
      if (permissions.canViewEvents) {
        this.fetchDeviceEvents();
      }
      if (shouldFetchOutlets) {
        this.fetchDeviceOutlets();
      }
    }

  };

  refreshAllData = () => {
    const serial = this.currentSerial();
    if (!serial) return;
    const permissions = this.getDevicePermissionsFor();
    if (!permissions.ready) return;

    this.setState({ deviceLoading: true });

    this.grabDeviceData();
    if (
      this.deviceSupportsOutlets() === true &&
      permissions.canViewOutlets
    ) {
      this.fetchDeviceOutlets({ serial, force: true });
    }
    if (permissions.canViewInlets) {
      this.fetchDeviceInlets({ serial, force: true });
      this.fetchDeviceBanks({ serial, force: true });
    }
    if (permissions.canViewSensors) {
      this.fetchDeviceSensors({ serial, force: true });
    }
    if (permissions.canViewEvents) {
      this.fetchDeviceEvents({ serial, force: true });
    }
    if (permissions.canViewActivityLog) {
      this.grabActivityLog(
        this.state.activityPage || 1,
        this.state.activityFilter,
        permissions,
      );
    }
    if (permissions.canViewFirmware) {
      this.props.fetchFwStatus(serial);
    }
    this.fetchConf({ useCache: false, force: true });
  };

  updateCurrentDevice = (patch = {}) => {
    if (!patch || typeof patch !== "object") {
      return;
    }

    this.setDeviceData(patch);
  };

  fetchDeviceOutlets = ({ serial, force = false } = {}) => {
    const targetSerial = serial || this.currentSerial();
    if (!targetSerial) return Promise.resolve([]);
    const permissions = this.getDevicePermissionsFor();
    if (!permissions.ready || !permissions.canViewOutlets) {
      return Promise.resolve(this.state.device?.outlets || []);
    }

    const supportsOutlets = this.deviceSupportsOutlets();
    if (supportsOutlets === false) {
      this.setState((prevState) => {
        if (!prevState.outletsLoading && prevState.outletsLoaded) {
          return null;
        }

        return {
          outletsLoading: false,
          outletsLoaded: true,
        };
      });
      return Promise.resolve(this.state.device?.outlets || []);
    }

    if (supportsOutlets !== true) {
      return Promise.resolve(this.state.device?.outlets || []);
    }

    if (!force && this.outletsRequest) {
      return this.outletsRequest;
    }

    if (this.state.outletsLoaded && !force) {
      return Promise.resolve(this.state.device?.outlets || []);
    }

    this.setState({ outletsLoading: true });

    const encodedSerial = encodeURIComponent(targetSerial);
    const request = axios
      .get(`/v2/devices/${encodedSerial}/outlets`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => {
        const outlets = Array.isArray(res?.data?.data) ? res.data.data : [];
        this.setDeviceData(
          { enclosureSerialNumber: targetSerial, outlets },
          {
            outletsLoading: false,
            outletsLoaded: true,
            deviceOffline: false,
            deviceOfflineReason: null,
          }
        );
        return outlets;
      })
      .catch((err) => {
        if (this.isOfflineError(err)) {
          const outlets = Array.isArray(err?.response?.data?.data)
            ? err.response.data.data
            : [];
          const message = this.offlineMessageFromError(
            err,
            "Device is offline. Showing last known outlet information."
          );

          this.setDeviceData(
            { enclosureSerialNumber: targetSerial, outlets },
            {
              outletsLoading: false,
              outletsLoaded: true,
              deviceOffline: true,
              deviceOfflineReason: message,
            }
          );
          return outlets;
        }

        console.error(err);
        this.setState({ outletsLoading: false });
        throw err;
      })
      .finally(() => {
        this.outletsRequest = null;
      });

    this.outletsRequest = request;
    return request;
  };

  fetchDeviceInlets = ({ serial, force = false } = {}) => {
    const targetSerial = serial || this.currentSerial();
    if (!targetSerial) return Promise.resolve([]);
    const permissions = this.getDevicePermissionsFor();
    if (!permissions.ready || !permissions.canViewInlets) {
      return Promise.resolve(this.state.device?.inlets || []);
    }

    if (!force && this.inletsRequest) {
      return this.inletsRequest;
    }

    if (this.state.inletsLoaded && !force) {
      return Promise.resolve(this.state.device?.inlets || []);
    }

    this.setState({ inletsLoading: true });

    const encodedSerial = encodeURIComponent(targetSerial);
    const request = axios
      .get(`/v2/devices/${encodedSerial}/inlets`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => {
        const inlets = Array.isArray(res?.data?.data) ? res.data.data : [];
        this.setDeviceData(
          { enclosureSerialNumber: targetSerial, inlets },
          {
            inletsLoading: false,
            inletsLoaded: true,
            deviceOffline: false,
            deviceOfflineReason: null,
          }
        );
        return inlets;
      })
      .catch((err) => {
        if (this.isOfflineError(err)) {
          const inlets = Array.isArray(err?.response?.data?.data)
            ? err.response.data.data
            : [];
          const message = this.offlineMessageFromError(
            err,
            "Device is offline. Showing last known inlet information."
          );

          this.setDeviceData(
            { enclosureSerialNumber: targetSerial, inlets },
            {
              inletsLoading: false,
              inletsLoaded: true,
              deviceOffline: true,
              deviceOfflineReason: message,
            }
          );
          return inlets;
        }

        console.error(err);
        this.setState({ inletsLoading: false });
        throw err;
      })
      .finally(() => {
        this.inletsRequest = null;
      });

    this.inletsRequest = request;
    return request;
  };

  fetchDeviceBanks = ({ serial, force = false } = {}) => {
    const targetSerial = serial || this.currentSerial();
    if (!targetSerial) return Promise.resolve([]);
    const permissions = this.getDevicePermissionsFor();
    if (!permissions.ready || !permissions.canViewInlets) {
      return Promise.resolve(this.state.device?.banks || []);
    }

    if (!force && this.banksRequest) {
      return this.banksRequest;
    }

    if (this.state.banksLoaded && !force) {
      return Promise.resolve(this.state.device?.banks || []);
    }

    this.setState({ banksLoading: true });

    const encodedSerial = encodeURIComponent(targetSerial);
    const request = axios
      .get(`/v2/devices/${encodedSerial}/banks`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => {
        const banks = Array.isArray(res?.data?.data) ? res.data.data : [];
        this.setDeviceData(
          { enclosureSerialNumber: targetSerial, banks },
          {
            banksLoading: false,
            banksLoaded: true,
            deviceOffline: false,
            deviceOfflineReason: null,
          }
        );
        return banks;
      })
      .catch((err) => {
        if (this.isOfflineError(err)) {
          const banks = Array.isArray(err?.response?.data?.data)
            ? err.response.data.data
            : [];
          const message = this.offlineMessageFromError(
            err,
            "Device is offline. Showing last known bank information."
          );

          this.setDeviceData(
            { enclosureSerialNumber: targetSerial, banks },
            {
              banksLoading: false,
              banksLoaded: true,
              deviceOffline: true,
              deviceOfflineReason: message,
            }
          );
          return banks;
        }

        console.error(err);
        this.setState({ banksLoading: false });
        throw err;
      })
      .finally(() => {
        this.banksRequest = null;
      });

    this.banksRequest = request;
    return request;
  };

  fetchDeviceSensors = ({ serial, force = false } = {}) => {
    const targetSerial = serial || this.currentSerial();
    if (!targetSerial) return Promise.resolve([]);
    const permissions = this.getDevicePermissionsFor();
    if (!permissions.ready || !permissions.canViewSensors) {
      return Promise.resolve(this.state.device?.sensors || []);
    }

    if (!force && this.sensorsRequest) {
      return this.sensorsRequest;
    }

    if (this.state.sensorsLoaded && !force) {
      return Promise.resolve(this.state.device?.sensors || []);
    }

    this.setState({ sensorsLoading: true });

    const encodedSerial = encodeURIComponent(targetSerial);
    const request = axios
      .get(`/v2/devices/${encodedSerial}/sensors`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => {
        const sensors = Array.isArray(res?.data?.data) ? res.data.data : [];
        this.setDeviceData(
          { enclosureSerialNumber: targetSerial, sensors },
          {
            sensorsLoading: false,
            sensorsLoaded: true,
            deviceOffline: false,
            deviceOfflineReason: null,
          }
        );
        return sensors;
      })
      .catch((err) => {
        if (this.isOfflineError(err)) {
          const sensors = Array.isArray(err?.response?.data?.data)
            ? err.response.data.data
            : [];
          const message = this.offlineMessageFromError(
            err,
            "Device is offline. Showing last known sensor information."
          );

          this.setDeviceData(
            { enclosureSerialNumber: targetSerial, sensors },
            {
              sensorsLoading: false,
              sensorsLoaded: true,
              deviceOffline: true,
              deviceOfflineReason: message,
            }
          );
          return sensors;
        }

        console.error(err);
        this.setState({ sensorsLoading: false });
        throw err;
      })
      .finally(() => {
        this.sensorsRequest = null;
      });

    this.sensorsRequest = request;
    return request;
  };

  fetchDeviceEvents = ({ serial, force = false } = {}) => {
    const targetSerial = serial || this.currentSerial();
    if (!targetSerial) return Promise.resolve([]);
    const permissions = this.getDevicePermissionsFor();
    if (!permissions.ready || !permissions.canViewEvents) {
      return Promise.resolve(this.state.device?.events || []);
    }

    if (!force && this.eventsRequest) {
      return this.eventsRequest;
    }

    if (this.state.eventsLoaded && !force) {
      return Promise.resolve(this.state.device?.events || []);
    }

    this.setState({ eventsLoading: true });

    const encodedSerial = encodeURIComponent(targetSerial);
    const request = axios
      .get(`/v2/devices/${encodedSerial}/events`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => {
        const events = Array.isArray(res?.data?.data) ? res.data.data : [];
        this.setDeviceData(
          { enclosureSerialNumber: targetSerial, events },
          {
            eventsLoading: false,
            eventsLoaded: true,
            deviceOffline: false,
            deviceOfflineReason: null,
          }
        );
        return events;
      })
      .catch((err) => {
        if (this.isOfflineError(err)) {
          const events = Array.isArray(err?.response?.data?.data)
            ? err.response.data.data
            : [];
          const message = this.offlineMessageFromError(
            err,
            "Device is offline. Displaying last known event information."
          );

          this.setDeviceData(
            { enclosureSerialNumber: targetSerial, events },
            {
              eventsLoading: false,
              eventsLoaded: true,
              deviceOffline: true,
              deviceOfflineReason: message,
            }
          );
          return events;
        }

        console.error(err);
        this.setState({ eventsLoading: false });
        throw err;
      })
      .finally(() => {
        this.eventsRequest = null;
      });

    this.eventsRequest = request;
    return request;
  };
  fetchConf = ({ useCache = false, force = false, device: deviceOverride } = {}) => {
    const device = deviceOverride || this.state.device;
    const rawSerial =
      device?.enclosureSerialNumber || this.props.match.params.enclosureSerialNumber;

    if (!rawSerial) {
      return Promise.resolve(null);
    }

    const serial = String(rawSerial);
    const currentSerial =
      this.state.confSerial ?? this.state.conf?.enclosureSerialNumber ?? null;

    if (!force) {
      if (this.confRequest && this.confRequestSerial === serial) {
        return this.confRequest;
      }

      if (
        currentSerial === serial &&
        this.state.conf &&
        !this.state.confLoading
      ) {
        return Promise.resolve(this.state.conf);
      }

      if (this.state.confLoading && currentSerial === serial) {
        return this.confRequest || Promise.resolve(null);
      }
    }

    const isLtePdu = device?.modelNumber?.endsWith("M01");
    const shouldUseCache = useCache && !isLtePdu;

    this.setState((prevState) => {
      const prevSerial =
        prevState.confSerial ?? prevState.conf?.enclosureSerialNumber ?? null;
      const shouldKeepCurrent = !force && prevSerial === serial;

      return {
        confLoading: true,
        conf: shouldKeepCurrent ? prevState.conf : null,
        confSerial: shouldKeepCurrent ? prevState.confSerial : null,
      };
    });

    const request = axios
      .get(
        `/v2/conf?${shouldUseCache ? "cache=true" : "cache=false"}&enclosure_serial_number=${encodeURIComponent(
          serial
        )}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then((res) => {
        if (!this.confRequest || this.confRequest === request) {
          this.setState({
            conf: (res.data?.data || [])[0] || null,
            confLoading: false,
            confSerial: serial,
          });
        }
        return (res.data?.data || [])[0] || null;
      })
      .catch((err) => {
        console.error(err);
        if (!this.confRequest || this.confRequest === request) {
          this.setState({ confLoading: false });
        }
        return null;
      })
      .finally(() => {
        if (this.confRequest === request) {
          this.confRequest = null;
          this.confRequestSerial = null;
        }
      });

    this.confRequest = request;
    this.confRequestSerial = serial;

    return request;
  };
  grabActivityLog = (
    page = 1,
    action = this.state.activityFilter,
    permissions = this.getDevicePermissionsFor(),
  ) => {
    const serial = this.currentSerial();
    if (!serial || !permissions.ready || !permissions.canViewActivityLog) {
      this.setState({ activityLoading: false });
      return Promise.resolve([]);
    }

    this.setState({
      activityLoading: true,
    });
    const actionParam = action ? `&action=${action}` : "";
    return axios
      .get(
        `/v2/activity?enclosure_serial_number=${serial}&limit=10&page=${page}${actionParam}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then((res) => {
        this.setState({
          activityLog: res.data.data,
          activityMeta: res.data.meta || {},
          activityPage: page,
          activityLoading: false,
          activityLoaded: true,
          activitySerial: serial,
        });
        return res.data.data;
      })
      .catch((err) => {
        console.error(err);
        this.setState({
          activityLoading: false,
        });
        return [];
      });
  };

  handleActivityFilter = (val) => {
    this.setState({ activityFilter: val }, () => this.grabActivityLog(1, val));
  };

  updateOutlet = (outletId, changes, cb = (err, udpatedOutlet) => {}) => {
    const permissions = this.getDevicePermissionsFor();
    const keys = Object.keys(changes || {});
    const hasStateChange = Object.prototype.hasOwnProperty.call(
      changes || {},
      "state",
    );
    const hasOnlyStateChange = keys.length === 1 && hasStateChange;

    if (
      (hasStateChange && !permissions.canSwitchOutlets) ||
      (!hasOnlyStateChange && !permissions.canEditOutlets)
    ) {
      const err = new Error("Outlet operation is not allowed for this role.");
      NotificationManager.alert(
        hasStateChange && !permissions.canSwitchOutlets
          ? "Your role does not allow outlet switching."
          : "Your role does not allow outlet editing.",
      );
      cb(err);
      return Promise.resolve(null);
    }

    // axios call to /v1/outlets/OUTLET_ID as a PUT, body is changes
    return axios
      .put(`/v1/outlets/${outletId}`, changes, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((res) => {
        const returnedOutlet = res.data.data;
        cb(null, returnedOutlet);
        NotificationManager.success(
          `Outlet ${returnedOutlet.outlet_id} updated successfully`
        );
        // update state with the returned outlet. dont replace, add on
        this.setState((prevState) => {
          if (!prevState.device) return null;
          const updatedOutlets = prevState.device.outlets.map((outlet) => {
            if (outlet.outlet_id === returnedOutlet.outlet_id) {
              return {
                ...outlet,
                ...returnedOutlet,
              };
            }
            return outlet;
          });
          return {
            device: {
              ...prevState.device,
              outlets: updatedOutlets,
            },
          };
        });
        // if changes.state === "REBOOT", trigger a follow-up refresh after the reboot window
        if (changes.state == "REBOOT") {
          const rebootTimeInSeconds = returnedOutlet.customRebootTime;
          const rebootTimeInMs = rebootTimeInSeconds * 1000;
          setTimeout(() => {
            this.grabDeviceData();
            this.fetchDeviceOutlets({
              serial:
                returnedOutlet.enclosureSerialNumber || this.currentSerial(),
              force: true,
            });
          }, rebootTimeInMs);
        }
      })
      .catch((err) => {
        console.error(err);
        NotificationManager.alert(
          `Failed to update outlet ${outletId}`
        );
        cb(err);
      });
  };

  createEvent = (enclosureSerialNumber, newEvent, cb = () => {}) => {
    // axios call to /v1/devices/:enclosureSerialNumber/events POST
    return axios
      .post(
        `/v1/devices/${enclosureSerialNumber}/events`,
        newEvent,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then((res) => {
        NotificationManager.success(
          `Event ${res.data.data.name} created successfully`
        );
        cb(null, res.data.data);
        this.setState((prevState) => {
          if (!prevState.device) return null;
          return {
            device: {
              ...prevState.device,
              events: [...prevState.device.events, res.data.data],
            },
            eventsLoaded: true,
          };
        });
      })
      .catch((err) => {
        const message = apiErrorMessageFromError(
          err,
          "Failed to create event."
        );
        cb(err)
        console.error(err);
        NotificationManager.alert(message);
      });



  }
  removeEvent = (enclosureSerialNumber, eventId, cb = () => {}) => {
    // axios call to /v1/devices/:enclosureSerialNumber/events/:eventId DELETE
    return axios
      .delete(
        `/v1/devices/${enclosureSerialNumber}/events/${eventId}`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then((res) => {
        NotificationManager.success(
          `Event ${eventId} deleted successfully`
        );
        cb(null, res.data.data);
        this.setState((prevState) => {
          if (!prevState.device) return null;
          return {
            device: {
              ...prevState.device,
              events: prevState.device.events.filter(
                (event) => event.id !== eventId
              ),
            },
            eventsLoaded: true,
          };
        });
      })
      .catch((err) => {
        cb(err)
        console.error(err);
        NotificationManager.alert(
          `Failed to delete event ${eventId}`
        );
      });
  }

  updateEvent = (enclosureSerialNumber, eventId, changes, cb = () => {}) => {
    // axios call to /v1/devices/:enclosureSerialNumber/events/:eventId PUT
    return axios
      .put(
        `/v1/devices/${enclosureSerialNumber}/events/${eventId}`,
        changes,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then((res) => {
        NotificationManager.success(
          `Event ${eventId} updated successfully`
        );
        cb(null, res.data.data);
        this.setState((prevState) => {
          if (!prevState.device) return null;
          return {
            device: {
              ...prevState.device,
              events: prevState.device.events.map((event) =>
                event.id == eventId ? { ...event, ...changes } : event
              ),
            },
            eventsLoaded: true,
          };
        });
      })
      .catch((err) => {
        const message = apiErrorMessageFromError(
          err,
          `Failed to update event ${eventId}`
        );
        cb(err)
        console.error(err);
        NotificationManager.alert(message);
      });
  
  }
  unpair = (cb = () => {}) => {
    this.props.removeResource(
      "devices",
      this.props.match.params.enclosureSerialNumber,
      (err, res) => {
        cb();
        this.props.history.replace("/devices/connected");
      },
      "enclosureSerialNumber"
    );
  };

  sectionMatchesPath = (
    section,
    pathname = this.props.location.pathname,
  ) => {
    if (!section?.path || !pathname) return false;

    return Boolean(
      matchPath(pathname, {
        path: section.path,
        exact: section.exact === undefined ? true : section.exact,
      })
    );
  };

  shouldShowRouteLoading = (
    pathname = this.props.location.pathname,
    sections = this.sections(),
  ) => {
    const permissions = this.getDevicePermissionsFor();
    const routeResolutionPending = !this.state.deviceLoaded || !permissions.ready;

    if (!routeResolutionPending) {
      return false;
    }

    return (sections || []).some(
      (section) => section.disabled && this.sectionMatchesPath(section, pathname)
    );
  };

  renderRouteLoading = () => (
    <div
      style={{
        minHeight: "240px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Loading black description="Loading device page..." />
    </div>
  );

  sections = () => {
    const shellState = this.getShellState();
    const permissions = this.getDevicePermissionsFor();
    const canViewInlets = permissions.ready && permissions.canViewInlets;
    const canViewOutlets = permissions.ready && permissions.canViewOutlets;
    const canViewEvents = permissions.ready && permissions.canViewEvents;
    const canViewSensors = permissions.ready && permissions.canViewSensors;
    const canEditEvents = permissions.ready && permissions.canEditEvents;
    const inletsLoading =
      this.state.inletsLoading || !this.state.inletsLoaded;
    const outletsLoading =
      this.state.outletsLoading || !this.state.outletsLoaded;
    const eventsLoading =
      this.state.eventsLoading || !this.state.eventsLoaded;
    const sensorsLoading =
      this.state.sensorsLoading || !this.state.sensorsLoaded;
    return [
      {
        label: "Details Redirect",
        icon: "public",
        path: `/devices/connected/${this.props.match.params.enclosureSerialNumber}/details`,
        component: () => (
          <Redirect
            to={`/devices/connected/${this.props.match.params.enclosureSerialNumber}/overview`}
          />
        ),
        exact: true,
        unlisted: true,
      },
      {
        label: "Overview",
        icon: "dashboard",
        path: `/devices/connected/${this.props.match.params.enclosureSerialNumber}/overview`,
        component: DeviceOverview,
        props: {
          ...this.props,
          match: this.props.match,
          history: this.props.history,
          device: this.state.device,
          conf: this.state.conf,
          confLoading: this.state.confLoading,
          events: this.state.device?.events || [],
          eventsLoading: this.state.eventsLoading,
          outlets: this.state.device?.outlets || [],
          outletsLoading: this.state.outletsLoading,
          updateOutlet: this.updateOutlet,
          user: this.props.user,
          resources: this.props.resources,
          deviceOffline: this.state.deviceOffline,
          offlineReason: this.state.deviceOfflineReason,
          shellState,
          effectivePermissions: permissions,
          refreshDevice: this.grabDeviceData,
          onDeviceDataUpdate: this.updateCurrentDevice,
        },
      },
      {
        label: "Power Consumption",
        icon: "power",
        path: `/devices/connected/${this.props.match.params.enclosureSerialNumber}/inlets`,
        props: {
          inlets: this.state.device?.inlets || [],
          banks: this.state.device?.banks || [],
          device: this.state.device,
          loading: inletsLoading,
          loaded: this.state.inletsLoaded,
          user: this.props.user,
        },
        component: DevicePageInlet,
        disabled: !canViewInlets,
      },
      {
        label: "Manage Outlets",
        icon: "outlet",
        path: `/devices/connected/${this.props.match.params.enclosureSerialNumber}/outlets`,
        props: {
          outlets: this.state.device?.outlets || [],
          device: this.state.device,
          loading: outletsLoading,
          loaded: this.state.outletsLoaded,
          user: this.props.user,
          activityLog: this.state.activityLog,
          activityLoading: this.state.activityLoading,
          grabActivityLog: this.grabActivityLog,
          updateOutlet: this.updateOutlet,
          history: this.props.history,
          refreshOutlets: this.fetchDeviceOutlets,
          refreshDevice: this.grabDeviceData,
          effectivePermissions: permissions,
        },
        exact: true,
        disabled:
          !(
            this.state.device?.outletSwitchingSupported ||
            this.state.device?.outletPwrMeasurementsSupported
          ) || !canViewOutlets,
        component: DevicePageOutlets,
      },
      {
        label: "Outlet Details",
        icon: "outlet",
        path: `/devices/connected/${this.props.match.params.enclosureSerialNumber}/outlets/:section_id`,
        props: {
          outletId: this.props.match.params.section_id,
          outlets: this.state.device?.outlets || [],
          device: this.state.device,
          loading: outletsLoading,
          loaded: this.state.outletsLoaded,
          user: this.props.user,
          updateOutlet: this.updateOutlet,
          effectivePermissions: permissions,
          activityLog: this.state.activityLog,
          activityLoading: this.state.activityLoading,
          history: this.props.history,
          refreshOutlets: this.fetchDeviceOutlets,
        },
        component: DevicePageOutletPage,
        disabled:
          !(
            this.state.device?.outletSwitchingSupported ||
            this.state.device?.outletPwrMeasurementsSupported
          ) || !canViewOutlets,
        unlisted: true,
        // disabled: true,
      },
      {
        label: "Diagnostics",
        icon: "troubleshoot",
        path: `/devices/connected/${this.props.match.params.enclosureSerialNumber}/diagnostics`,
        component: DevicePageDiagnostics,
        props: {
          user: this.props.user,
          deviceOffline: this.state.deviceOffline,
          offlineReason: this.state.deviceOfflineReason,
          shellState,
        },
      },
      {
        id: "shell-redirect",
        label: "Shell Redirect",
        icon: "terminal",
        path: `/devices/connected/${this.props.match.params.enclosureSerialNumber}/shell`,
        component: () => (
          <Redirect
            to={{
              pathname: `/devices/connected/${this.props.match.params.enclosureSerialNumber}/diagnostics`,
              hash: "#shell-workspace",
            }}
          />
        ),
        exact: true,
        unlisted: true,
      },
      {
        label: "Create Alert",
        icon: "notifications",
        path: `/devices/connected/${this.props.match.params.enclosureSerialNumber}/alerts/new`,
        component: DevicePageAlertItemPage,
        exact: true,
        props: {
          eventId: "new",
          isEditMode: true,
          enclosureSerialNumber: this.props.match.params.enclosureSerialNumber,
          alertsPath: buildDeviceAlertsPath(
            this.props.match.params.enclosureSerialNumber,
          ),
          device: this.state.device,
          conf: this.state.conf,
          banks: this.state.device?.banks || [],
          outlets: this.state.device?.outlets || [],
          sensors: this.state.device?.sensors || [],
          loading: this.state.deviceLoading || !this.state.deviceLoaded,
          inlets: this.state.device?.inlets || [],
          loaded: this.state.deviceLoaded,
          events: this.state.device?.events || [],
          match: this.props.match,
          history: this.props.history,
          createEvent: this.createEvent,
          removeEvent: this.removeEvent,
          updateEvent: this.updateEvent,
          canEditEvents,
          deviceOffline: this.state.deviceOffline,
          offlineReason: this.state.deviceOfflineReason,
        },
        unlisted: true,
        disabled: !canEditEvents,
      },
      {
        label: "Edit Alert",
        icon: "notifications",
        path: `/devices/connected/${this.props.match.params.enclosureSerialNumber}/alerts/:eventId/edit`,
        component: DevicePageAlertItemPage,
        exact: true,
        props: {
          eventId: this.props.match.params.section_id,
          isEditMode: true,
          enclosureSerialNumber: this.props.match.params.enclosureSerialNumber,
          alertsPath: buildDeviceAlertsPath(
            this.props.match.params.enclosureSerialNumber,
          ),
          detailsPath: buildAlertDetailsPath(
            this.props.match.params.enclosureSerialNumber,
            this.props.match.params.section_id,
          ),
          logsPath: buildAlertLogsPath(
            this.props.match.params.enclosureSerialNumber,
            this.props.match.params.section_id,
          ),
          device: this.state.device,
          conf: this.state.conf,
          banks: this.state.device?.banks || [],
          outlets: this.state.device?.outlets || [],
          sensors: this.state.device?.sensors || [],
          loading: eventsLoading,
          inlets: this.state.device?.inlets || [],
          loaded: this.state.eventsLoaded,
          events: this.state.device?.events || [],
          match: this.props.match,
          history: this.props.history,
          createEvent: this.createEvent,
          removeEvent: this.removeEvent,
          updateEvent: this.updateEvent,
          canEditEvents,
          deviceOffline: this.state.deviceOffline,
          offlineReason: this.state.deviceOfflineReason,
        },
        unlisted: true,
        disabled: !canEditEvents,
      },
      {
        label: "Alert Details",
        icon: "notifications",
        path: `/devices/connected/${this.props.match.params.enclosureSerialNumber}/alerts/:eventId`,
        component: DeviceAlertDetails,
        exact: true,
        props: {
          eventId: this.props.match.params.section_id,
          enclosureSerialNumber: this.props.match.params.enclosureSerialNumber,
          alertsPath: buildDeviceAlertsPath(
            this.props.match.params.enclosureSerialNumber,
          ),
          editPath: buildAlertEditPath(
            this.props.match.params.enclosureSerialNumber,
            this.props.match.params.section_id,
          ),
          logsPath: buildAlertLogsPath(
            this.props.match.params.enclosureSerialNumber,
            this.props.match.params.section_id,
          ),
          device: this.state.device,
          events: this.state.device?.events || [],
          loading: eventsLoading,
          loaded: this.state.eventsLoaded,
          deviceOffline: this.state.deviceOffline,
          offlineReason: this.state.deviceOfflineReason,
          canEditEvents,
        },
        unlisted: true,
        disabled: !canViewEvents,
      },
      {
        label: "Alerts",
        icon: "notifications",
        path: `/devices/connected/${this.props.match.params.enclosureSerialNumber}/alerts`,
        disabled: !canViewEvents,
        component: DevicePageAlerts,
        props: {
          device: this.state.device,
          loading: eventsLoading,
          loaded: this.state.eventsLoaded,
          events: this.state.device?.events || [],
          banks: this.state.device?.banks || [],
          sensors: this.state.device?.sensors || [],
          refreshEvents: this.fetchDeviceEvents,
          deviceOffline: this.state.deviceOffline,
          offlineReason: this.state.deviceOfflineReason,
          location: this.props.location,
          history: this.props.history,
          canEditEvents,
        }
      },
      {
        label: "Event History",
        icon: "history",
        path: `/devices/connected/${this.props.match.params.enclosureSerialNumber}/event-logs`,
        disabled: !canViewEvents,
        unlisted: true,
        component: LoggingEventLogs,
        props: {
          ...this.props,
          device: this.state.device,
          location: this.props.location,
          history: this.props.history,
          queryParams: {
            ...(this.props.queryParams || {}),
            enclosure_serial_number: this.props.match.params.enclosureSerialNumber,
          },
        },
      },
      {
        label: "Configuration",
        icon: "settings",
        path: `/devices/connected/${this.props.match.params.enclosureSerialNumber}/configuration`,
        exact: false,
        component: DevicePageConfiguration,
        props: {
          device: this.state.device,
          conf: this.state.conf,
          confLoading: this.state.confLoading,
          refreshConf: this.fetchConf,
          user: this.props.user,
          deviceOffline: this.state.deviceOffline,
          offlineReason: this.state.deviceOfflineReason,
          resources: this.props.resources,
          fetchFwStatus: this.props.fetchFwStatus,
          deviceLoaded: this.state.deviceLoaded,
          unpair: this.unpair,
          effectivePermissions: permissions,
          onDeviceDataUpdate: this.updateCurrentDevice,
        },
      },
      {
        label: "Sensors",
        icon: "device_thermostat",
        path: `/devices/connected/${this.props.match.params.enclosureSerialNumber}/sensors`,
        disabled: !canViewSensors,
        component: DevicePageSensors,
        props: {
          ...this.props,
          device: this.state.device,
          sensors: this.state.device?.sensors || [],
          sensorsLoading,
          sensorsLoaded: this.state.sensorsLoaded,
          refreshSensors: this.fetchDeviceSensors,
        },
      }
    ];
  };
  render() {
    const sections = this.sections();
    const isRefreshing =
      this.state.deviceLoading ||
      this.state.outletsLoading ||
      this.state.inletsLoading ||
      this.state.banksLoading ||
      this.state.sensorsLoading ||
      this.state.eventsLoading ||
      this.state.confLoading;

    const statusPending = !this.state.deviceLoaded;
    const offline = !statusPending && this.state.deviceOffline;
    const statusLabel = statusPending
      ? "Checking"
      : offline
      ? "Offline"
      : "Online";
    const serial = this.currentSerial();
    const device = this.state.device || {};
    const deviceName =
      device.deviceName ||
      device.last_known_name ||
      (serial ? `Device ${serial}` : "Device");
    const modelNumber = device.modelNumber ? String(device.modelNumber) : "";
    const lastHeardDate = device.lastHeard ? new Date(device.lastHeard) : null;
    const lastHeardValid =
      lastHeardDate && !Number.isNaN(lastHeardDate.getTime());
    const lastHeardDisplay = lastHeardValid
      ? formatDistanceToNow(lastHeardDate, { addSuffix: true })
      : "";
    const statusDetail = statusPending
      ? "Checking connection"
      : offline
      ? lastHeardDisplay
        ? `Last heard ${lastHeardDisplay}`
        : "Showing last known readings"
      : "Live readings current";
    const identityMeta = [
      serial ? `Serial ${serial}` : null,
      modelNumber ? `Model ${modelNumber}` : null,
    ].filter(Boolean);
    const refreshLabel = isRefreshing
      ? "Refreshing device data"
      : offline
      ? "Check device connection"
      : "Refresh device data";

    const statusPillStyles = statusPending
      ? {
          background: "var(--overview-neutral-bg, var(--app-surface-3))",
          border: "1px solid var(--overview-neutral-border, var(--app-border-strong))",
          color: "var(--overview-neutral-fg, var(--app-text-muted))",
        }
      : offline
      ? {
          background: "var(--warning-background)",
          border: "1px solid var(--warning-border-color)",
          color: "var(--warning-color)",
        }
      : {
          background: "var(--success-background)",
          border: "1px solid var(--success-border-color)",
          color: "var(--success-color)",
        };

    // console.log(sections);
    // if (this.state.deviceLoading) {
    //   return <Loading black />
    // }
    // const foundDevice = this.props.resources.devices.find(d => d.enclosureSerialNumber === this.props.match.params.enclosureSerialNumber);
    return (
      <div>
        <SubHeader
          sections={sections
            .filter((section) => !section.disabled)
            .filter((section) => !section.unlisted)}
        />
        <div style={{ padding: "0 24px" }}>
          <div
            style={{
              marginTop: "16px",
              marginBottom: "8px",
              padding: "14px 18px",
              borderRadius: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "14px",
              background: "var(--app-surface-1)",
              border: "1px solid var(--app-border)",
              boxShadow: "0 1px 2px rgba(15, 23, 42, 0.05)",
              color: "var(--app-text)",
            }}
          >
            <div style={{ flex: "1 1 320px", minWidth: 0 }}>
              <div
                style={{
                  fontSize: "18px",
                  lineHeight: 1.3,
                  fontWeight: 600,
                  color: "var(--app-text)",
                  overflowWrap: "anywhere",
                }}
              >
                {deviceName}
              </div>
              {identityMeta.length > 0 ? (
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "6px 12px",
                    marginTop: "6px",
                    color: "var(--app-text-muted)",
                    fontSize: "13px",
                    lineHeight: 1.4,
                  }}
                >
                  {identityMeta.map((item) => (
                    <span key={item}>{item}</span>
                  ))}
                </div>
              ) : null}
            </div>
            <div
              style={{
                flex: "1 1 260px",
                minWidth: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: "10px",
                flexWrap: "wrap",
              }}
            >
              <div
                style={{
                  minWidth: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  gap: "10px",
                  flexWrap: "wrap",
                }}
              >
                <span
                  style={{
                    ...statusPillStyles,
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    borderRadius: "999px",
                    padding: "3px 9px",
                    fontSize: "12px",
                    fontWeight: 700,
                    lineHeight: 1.2,
                    whiteSpace: "nowrap",
                  }}
                >
                  <span
                    aria-hidden="true"
                    style={{
                      width: "6px",
                      height: "6px",
                      borderRadius: "999px",
                      background: "currentColor",
                      display: "inline-block",
                    }}
                  />
                  {statusLabel}
                </span>
                <span
                  style={{
                    fontSize: "13px",
                    lineHeight: 1.5,
                    color: "var(--app-text-muted)",
                    overflowWrap: "anywhere",
                  }}
                >
                  {statusDetail}
                </span>
              </div>
              <button
                type="button"
                className="button secondary"
                onClick={this.refreshAllData}
                disabled={isRefreshing || !serial}
                aria-label={refreshLabel}
                title={refreshLabel}
                style={{
                  padding: 0,
                  width: "34px",
                  height: "34px",
                  minWidth: "34px",
                  borderRadius: "4px",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "var(--app-control-bg)",
                  color: "var(--app-text)",
                  border: "1px solid var(--app-border)",
                  boxShadow: "none",
                  cursor: isRefreshing || !serial ? "default" : "pointer",
                  opacity: isRefreshing || !serial ? 0.7 : 1,
                  margin: "0px",
                  transition: "background-color 0.2s ease, border-color 0.2s ease",
                }}
              >
                {isRefreshing ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <Loading black size="20px" />
                  </div>
                ) : (
                  <i
                    className="material-icons"
                    aria-hidden="true"
                    style={{ fontSize: "20px", lineHeight: 1 }}
                  >
                    refresh
                  </i>
                )}
              </button>
            </div>
          </div>
        </div>
        <Switch>
          {sections &&
            sections.map((section) => {
              // if (section.disableAccess) return null;
              if (section.disabled) return null;

              return (
                <Route
                  key={section.label}
                  path={section.path}
                  exact={section.exact === undefined ? true : section.exact}
                  render={(props) => {
                    if (section.disabled) {
                      return null;
                    }
                    // const CompToRender = scrollTopOnMount(section.component);
                    const CompToRender = section.component;
                    return (
                      <CompToRender
                        {...(section.props || {})}
                        match={this.props.match}
                      />
                    );
                  }}
                />
              );
            })}
          <Route
            render={(props) => (
              this.shouldShowRouteLoading(props.location.pathname, sections) ? (
                this.renderRouteLoading()
              ) : (
                <NotFoundPage
                  {...props}
                  homePath={`/devices/connected/${serial}/overview`}
                  homeLabel="Go to device overview"
                />
              )
            )}
          />
        </Switch>
      </div>
    );
  }
}
